<template>
  <teleport to="body">
    <div>
      <transition name="fade">
        <div v-if="visible" class="my-dialog-bg"></div>
      </transition>
      <transition :name="direction === 'bottom' ? 'bottom' : 'fade'">
        <div v-if="visible" @click="cancel" :class="[direction]" class="my-dialog-container" @touchmove="touchmove">
          <div @click.stop class="my-dialog-inner">
            <slot></slot>
          </div>
        </div>
      </transition>
    </div>
  </teleport>
</template>

<script>
const OVERLAY = 'overlay-wrap'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    direction: {
      type: String,
      default: 'center', // bottom
    },
    prevent: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    visible(e) {
      if (e) {
        document.documentElement.classList.add(OVERLAY)
      } else {
        document.documentElement.classList.remove(OVERLAY)
      }
    },
  },
  beforeUnmount() {
    document.documentElement.classList.remove(OVERLAY)
  },
  emits: ['cancel', 'update:visible'],
  methods: {
    cancel() {
      this.$emit('update:visible', false)
      this.$emit('cancel', false)
    },
    touchmove(e) {
      if (this.prevent) {
        e.preventDefault()
      }
    },
  },
}
</script>

<style lang="less" scoped>
.my-dialog-bg {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
}
.my-dialog-container {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  .my-dialog-inner {
    position: relative;
  }
  &.center {
    align-items: center;
    .my-dialog-inner {
      animation: fadeZoomIn 0.38s cubic-bezier(0.8, 0, 0, 1.3) both;
    }
  }
  &.top {
    align-items: flex-start;
    .my-dialog-inner {
      animation: slideInDown 0.3s linear both;
    }
  }
  &.bottom {
    align-items: flex-end;
    .my-dialog-inner {
      animation: slideInUp 0.3s linear both;
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.bottom-enter-active,
.bottom-leave-active {
  transition: transform 0.3s;
  transform: translateY(0);
}
.bottom-enter-from,
.bottom-leave-to {
  transform: translateY(100%);
}
@keyframes fadeZoomIn {
  from {
    opacity: 0;
    transform: scale(0.1);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes slideInUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}
@keyframes slideInDown {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}
</style>
